import { takeLatest } from "redux-saga/effects";
import { apis } from "../../config/APIs";
import { sagaFunctions } from "../../utils";
import {
  CompanyProfile,
  UpdateCompanyProfile,
  ReportsApproval,
  UpdateReportsApproval,
  AdvanceApproval,
  UpdateAdvanceApproval,
  TripApproval,
  UpdateTripApproval,
  CompanySetting,
  AddCompanySetting,
  DeleteCompanySetting,
  CompanySettingStatus,
  UpdateCompanyTransaction,
  AddTransactionField,
  GetTransactionField,
  DeleteTransactionField,
  UpdateTransactionField,
  UpdateCompanyReport,
  AddReportField,
  GetReportField,
  DeleteReportField,
  UpdateReportField,
  UpdateCompanyAdvances,
  AddAdvancesField,
  GetAdvancesField,
  DeleteAdvancesField,
  UpdateAdvancesField,
  AddCostCenterField,
  GetCostCenterField,
  DeleteCostCenterField,
  UpdateCostCenterField,
  AddMerchantsField,
  GetMerchantsField,
  DeleteMerchantsField,
  UpdateMerchantsField,
  AddProjectsField,
  GetProjectsField,
  DeleteProjectsField,
  UpdateProjectsField,
  AddTripsField,
  GetTripsField,
  DeleteTripsField,
  UpdateCompanyTrips,
  UpdateTripsField,
  AddRoles,
  GetRolesPermissions,
  GetRoles,
  GetSingleRoles,
  UpdateRoles,
  AddDesignations,
  DeleteDesignations,
  GetDesignations,
  UpdateDesignations,
  GetSingleDesignations,
  GetUserFields,
  GetUserFieldsColumnTypes,
  GetSingleUserFields,
  AddUserFields,
  UpdateUserFields,
  DeleteUserFields,
  GetCustomFields,
  GetCompanyCountries,
  GetCompanyStates,
  GetCompanyCities,
  DeleteRole,
} from "./companySettings";

function getCompanyProfile(req) {
  return sagaFunctions(
    CompanyProfile,
    "get",
    apis.companyProfile,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function updateCompanyProfile(req) {
  return sagaFunctions(
    UpdateCompanyProfile,
    "post",
    apis.updateCompanyProfile,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getReportsApproval(req) {
  return sagaFunctions(
    ReportsApproval,
    "get",
    apis.reportApprovals,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function updateReportsApproval(req) {
  return sagaFunctions(
    UpdateReportsApproval,
    "post",
    apis.updateReportApprovals,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getAdvanceApproval(req) {
  return sagaFunctions(
    AdvanceApproval,
    "get",
    apis.advanceApprovals,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function updateAdvanceApproval(req) {
  return sagaFunctions(
    UpdateAdvanceApproval,
    "post",
    apis.updateAdvanceApprovals,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getTripApproval(req) {
  return sagaFunctions(TripApproval, "get", apis.tripApprovals, req.payload, {
    headers: {
      "Content-Type": "multipart/formdata",
    },
    skipSuccessMessage: true,
  })();
}

function updateTripApproval(req) {
  return sagaFunctions(
    UpdateTripApproval,
    "post",
    apis.updateTripApprovals,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getCompanySetting(req) {
  return sagaFunctions(
    CompanySetting,
    "get",
    apis.companySetting,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function updateCompanySettingStatus(req) {
  return sagaFunctions(
    CompanySettingStatus,
    "post",
    apis.companySettingStatus,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function addCompanySetting(req) {
  return sagaFunctions(
    AddCompanySetting,
    "post",
    apis.updateTransaction,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function deleteCompanySetting(req) {
  return sagaFunctions(
    DeleteCompanySetting,
    "post",
    apis.deleteCompanySetting,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

//  ===============================================================================================
// ===============================================================================================
// ===============================================================================================

function updateCompanyTransaction(req) {
  return sagaFunctions(
    UpdateCompanyTransaction,
    "post",
    apis.updateTransaction,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getTransactionField(req) {
  return sagaFunctions(
    GetTransactionField,
    "get",
    apis.transactionField,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function addTransactionField(req) {
  return sagaFunctions(
    AddTransactionField,
    "post",
    apis.transactionField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function deleteTransactionField(req) {
  return sagaFunctions(
    DeleteTransactionField,
    "post",
    apis.deleteTransactionField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function updateTransactionField(req) {
  return sagaFunctions(
    DeleteTransactionField,
    "post",
    apis.updateTransactionField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

//  ===============================================================================================
// ===============================================================================================
// ===============================================================================================

function updateCompanyReport(req) {
  return sagaFunctions(
    UpdateCompanyReport,
    "post",
    apis.updateReport,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getReportField(req) {
  return sagaFunctions(GetReportField, "get", apis.reportField, req.payload, {
    headers: {
      "Content-Type": "multipart/formdata",
    },
    skipSuccessMessage: true,
  })();
}

function addReportField(req) {
  return sagaFunctions(AddReportField, "post", apis.reportField, req.payload, {
    "Content-Type": "multipart/formdata",
  })();
}

function deleteReportField(req) {
  return sagaFunctions(
    DeleteReportField,
    "post",
    apis.deleteReportField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function updateReportField(req) {
  return sagaFunctions(
    DeleteReportField,
    "post",
    apis.updateReportField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

//  ===============================================================================================
// ===============================================================================================
// ===============================================================================================

function updateCompanyAdvances(req) {
  return sagaFunctions(
    UpdateCompanyAdvances,
    "post",
    apis.updateCompAdvances,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getAdvancesField(req) {
  return sagaFunctions(
    GetAdvancesField,
    "get",
    apis.advancesField,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function addAdvancesField(req) {
  return sagaFunctions(
    AddAdvancesField,
    "post",
    apis.advancesField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function deleteAdvancesField(req) {
  return sagaFunctions(
    DeleteAdvancesField,
    "post",
    apis.deleteAdvancesField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function updateAdvancesField(req) {
  return sagaFunctions(
    DeleteAdvancesField,
    "post",
    apis.updateAdvancesField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

//  ===============================================================================================
// ===============================================================================================
// ===============================================================================================

function getTripsField(req) {
  return sagaFunctions(GetTripsField, "get", apis.tripsField, req.payload, {
    headers: {
      "Content-Type": "multipart/formdata",
    },
    skipSuccessMessage: true,
  })();
}

function addTripsField(req) {
  return sagaFunctions(AddTripsField, "post", apis.tripsField, req.payload, {
    "Content-Type": "multipart/formdata",
  })();
}

function updateCompanyTrips(req) {
  return sagaFunctions(
    UpdateCompanyTrips,
    "post",
    apis.updateTrips,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function deleteTripsField(req) {
  return sagaFunctions(
    DeleteTripsField,
    "post",
    apis.deleteTripsField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function updateTripsField(req) {
  return sagaFunctions(
    DeleteTripsField,
    "post",
    apis.updateTripsField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

//  ===============================================================================================
// ===============================================================================================
// ===============================================================================================

function getCostCenterField(req) {
  return sagaFunctions(
    GetCostCenterField,
    "get",
    apis.costCenterField,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function addCostCenterField(req) {
  return sagaFunctions(
    AddCostCenterField,
    "post",
    apis.costCenterField,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function deleteCostCenterField(req) {
  return sagaFunctions(
    DeleteCostCenterField,
    "post",
    apis.deleteCostCenterField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function updateCostCenterField(req) {
  return sagaFunctions(
    DeleteCostCenterField,
    "post",
    apis.updateCostCenterField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

//  ===============================================================================================
// ===============================================================================================
// ===============================================================================================

function getMerchantsField(req) {
  return sagaFunctions(
    GetMerchantsField,
    "get",
    apis.merchantsField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function addMerchantsField(req) {
  return sagaFunctions(
    AddMerchantsField,
    "post",
    apis.merchantsField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function deleteMerchantsField(req) {
  return sagaFunctions(
    DeleteMerchantsField,
    "post",
    apis.deleteMerchantsField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function updateMerchantsField(req) {
  return sagaFunctions(
    DeleteMerchantsField,
    "post",
    apis.updateMerchantsField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

//  ===============================================================================================
// ===============================================================================================
// ===============================================================================================

function getProjectsField(req) {
  return sagaFunctions(
    GetProjectsField,
    "get",
    apis.projectsField,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function addProjectsField(req) {
  return sagaFunctions(
    AddProjectsField,
    "post",
    apis.projectsField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function deleteProjectsField(req) {
  return sagaFunctions(
    DeleteProjectsField,
    "post",
    apis.deleteProjectsField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function updateProjectsField(req) {
  return sagaFunctions(
    DeleteProjectsField,
    "post",
    apis.updateProjectsField,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

//  ===============================================================================================
// ===============================================================================================
// ===============================================================================================

function getRolesPermissions(req) {
  const cc = req.payload.cc;
  delete req.payload.cc;
  return sagaFunctions(
    GetRolesPermissions,
    "get",
    cc ? apis.ccrolesPermissions : apis.rolesPermissions,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getRoles(req) {
  return sagaFunctions(GetRoles, "get", apis.getRoles, req.payload, {
    headers: {
      "Content-Type": "multipart/formdata",
    },
    skipSuccessMessage: true,
  })();
}

function getSingleRoles(req) {
  return sagaFunctions(
    GetSingleRoles,
    "get",
    apis.getSingleRoles,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function addRoles(req) {
  return sagaFunctions(AddRoles, "post", apis.roles, req.payload, {
    "Content-Type": "multipart/formdata",
  })();
}

function updateRoles(req) {
  return sagaFunctions(UpdateRoles, "post", apis.updateRoles, req.payload, {
    "Content-Type": "multipart/formdata",
  })();
}

//  ===============================================================================================
// ===============================================================================================
// ===============================================================================================

function getUserFields(req) {
  return sagaFunctions(GetUserFields, "get", apis.getUserFields, req.payload, {
    headers: {
      "Content-Type": "multipart/formdata",
    },
    skipSuccessMessage: true,
  })();
}

function getUserFieldsColumnTypes(req) {
  return sagaFunctions(
    GetUserFieldsColumnTypes,
    "get",
    apis.userFieldsColumns,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getSingleUserFields(req) {
  return sagaFunctions(
    GetSingleUserFields,
    "get",
    apis.getSingleUserFields,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function addUserFields(req) {
  return sagaFunctions(AddUserFields, "post", apis.getUserFields, req.payload, {
    "Content-Type": "multipart/formdata",
  })();
}

function updateUserFields(req) {
  return sagaFunctions(
    UpdateUserFields,
    "post",
    apis.updateUserFields,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function deleteUserFields(req) {
  return sagaFunctions(
    DeleteUserFields,
    "post",
    apis.deleteUserFields,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

//  ===============================================================================================
// ===============================================================================================
// ===============================================================================================

function getDesignations(req) {
  return sagaFunctions(GetDesignations, "get", apis.designations, req.payload, {
    headers: {
      "Content-Type": "multipart/formdata",
    },
    skipSuccessMessage: true,
  })();
}

function getSingleDesignations(req) {
  return sagaFunctions(
    GetSingleDesignations,
    "get",
    apis.getSingleDesignations,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function addDesignations(req) {
  return sagaFunctions(
    AddDesignations,
    "post",
    apis.updateDesignations,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function deleteDesignations(req) {
  return sagaFunctions(
    DeleteDesignations,
    "post",
    apis.deleteDesignations,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function updateDesignations(req) {
  return sagaFunctions(
    AddDesignations,
    "post",
    apis.updateDesignations,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function deleteRole(req) {
  return sagaFunctions(DeleteRole, "post", apis.deleteRole, req.payload)();
}

function getCustomFields(req) {
  return sagaFunctions(
    GetCustomFields,
    "get",
    apis.getCustomFields,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getCompanyCities(req) {
  return sagaFunctions(
    GetCompanyCities,
    "get",
    apis.companyCities,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}
function getCompanyStates(req) {
  return sagaFunctions(
    GetCompanyStates,
    "get",
    apis.companyStates,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}
function getCompanyCountries(req) {
  return sagaFunctions(
    GetCompanyCountries,
    "get",
    apis.companyCountries,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

export function* companySettingWatcher() {
  yield takeLatest(CompanyProfile.REQUEST, getCompanyProfile);
  yield takeLatest(DeleteRole.REQUEST, deleteRole);
  yield takeLatest(UpdateCompanyProfile.REQUEST, updateCompanyProfile);

  yield takeLatest(ReportsApproval.REQUEST, getReportsApproval);
  yield takeLatest(UpdateReportsApproval.REQUEST, updateReportsApproval);

  yield takeLatest(AdvanceApproval.REQUEST, getAdvanceApproval);
  yield takeLatest(UpdateAdvanceApproval.REQUEST, updateAdvanceApproval);

  yield takeLatest(TripApproval.REQUEST, getTripApproval);
  yield takeLatest(UpdateTripApproval.REQUEST, updateTripApproval);

  yield takeLatest(CompanySetting.REQUEST, getCompanySetting);
  yield takeLatest(CompanySettingStatus.REQUEST, updateCompanySettingStatus);
  yield takeLatest(AddCompanySetting.REQUEST, addCompanySetting);
  yield takeLatest(DeleteCompanySetting.REQUEST, deleteCompanySetting);

  yield takeLatest(UpdateCompanyTransaction.REQUEST, updateCompanyTransaction);
  yield takeLatest(GetTransactionField.REQUEST, getTransactionField);
  yield takeLatest(AddTransactionField.REQUEST, addTransactionField);
  yield takeLatest(DeleteTransactionField.REQUEST, deleteTransactionField);
  yield takeLatest(UpdateTransactionField.REQUEST, updateTransactionField);

  yield takeLatest(UpdateCompanyReport.REQUEST, updateCompanyReport);
  yield takeLatest(GetReportField.REQUEST, getReportField);
  yield takeLatest(AddReportField.REQUEST, addReportField);
  yield takeLatest(DeleteReportField.REQUEST, deleteReportField);
  yield takeLatest(UpdateReportField.REQUEST, updateReportField);

  yield takeLatest(UpdateCompanyAdvances.REQUEST, updateCompanyAdvances);
  yield takeLatest(GetAdvancesField.REQUEST, getAdvancesField);
  yield takeLatest(AddAdvancesField.REQUEST, addAdvancesField);
  yield takeLatest(DeleteAdvancesField.REQUEST, deleteAdvancesField);
  yield takeLatest(UpdateAdvancesField.REQUEST, updateAdvancesField);

  yield takeLatest(GetTripsField.REQUEST, getTripsField);
  yield takeLatest(AddTripsField.REQUEST, addTripsField);
  yield takeLatest(UpdateCompanyTrips.REQUEST, updateCompanyTrips);
  yield takeLatest(DeleteTripsField.REQUEST, deleteTripsField);
  yield takeLatest(UpdateTripsField.REQUEST, updateTripsField);

  yield takeLatest(GetCostCenterField.REQUEST, getCostCenterField);
  yield takeLatest(AddCostCenterField.REQUEST, addCostCenterField);
  yield takeLatest(DeleteCostCenterField.REQUEST, deleteCostCenterField);
  yield takeLatest(UpdateCostCenterField.REQUEST, updateCostCenterField);

  yield takeLatest(GetMerchantsField.REQUEST, getMerchantsField);
  yield takeLatest(AddMerchantsField.REQUEST, addMerchantsField);
  yield takeLatest(DeleteMerchantsField.REQUEST, deleteMerchantsField);
  yield takeLatest(UpdateMerchantsField.REQUEST, updateMerchantsField);

  yield takeLatest(GetProjectsField.REQUEST, getProjectsField);
  yield takeLatest(AddProjectsField.REQUEST, addProjectsField);
  yield takeLatest(DeleteProjectsField.REQUEST, deleteProjectsField);
  yield takeLatest(UpdateProjectsField.REQUEST, updateProjectsField);

  yield takeLatest(GetRolesPermissions.REQUEST, getRolesPermissions);
  yield takeLatest(GetRoles.REQUEST, getRoles);
  yield takeLatest(GetSingleRoles.REQUEST, getSingleRoles);
  yield takeLatest(AddRoles.REQUEST, addRoles);
  yield takeLatest(UpdateRoles.REQUEST, updateRoles);

  yield takeLatest(GetUserFields.REQUEST, getUserFields);
  yield takeLatest(GetUserFieldsColumnTypes.REQUEST, getUserFieldsColumnTypes);
  yield takeLatest(GetSingleUserFields.REQUEST, getSingleUserFields);
  yield takeLatest(AddUserFields.REQUEST, addUserFields);
  yield takeLatest(UpdateUserFields.REQUEST, updateUserFields);
  yield takeLatest(DeleteUserFields.REQUEST, deleteUserFields);

  yield takeLatest(GetDesignations.REQUEST, getDesignations);
  yield takeLatest(AddDesignations.REQUEST, addDesignations);
  yield takeLatest(DeleteDesignations.REQUEST, deleteDesignations);
  yield takeLatest(UpdateDesignations.REQUEST, updateDesignations);
  yield takeLatest(GetSingleDesignations.REQUEST, getSingleDesignations);

  yield takeLatest(GetCustomFields.REQUEST, getCustomFields);

  yield takeLatest(GetCompanyCountries.REQUEST, getCompanyCountries);
  yield takeLatest(GetCompanyStates.REQUEST, getCompanyStates);
  yield takeLatest(GetCompanyCities.REQUEST, getCompanyCities);
}
